import { CollectionViewer, DataSource } from '@angular/cdk/collections';
import { Batch } from '../../../models/batch';
import { Observable } from 'rxjs';

export class BatchData implements DataSource<Batch> {

    constructor(private source$: Observable<Batch[]>) {}

    connect(collectionViewer: CollectionViewer): Observable<Batch[]> {
        return this.source$;
    }

    disconnect(collectionViewer: CollectionViewer): void {
    }

}
